import { useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { TextInput, TextAreaInput } from '../Misc/FormInput';

const COOP_ELIGIBILITY_OPTIONS = [
    {
        label: 'NO Co-op Program',
        value: 'NO Co-op program',
        values: ['NO Co-op program', 'NO Co-op program-Track Expense'],
    },
    {
        label: 'YES Co-op, Send Invoice',
        value: 'YES Co-op, Send Invoice',
        values: ['YES Co-op by Invoice', 'YES Co-op, Send Invoice'],
    },
    {
        label: 'YES Co-op, Do Not Send Invoice',
        value: 'YES Co-op, Do Not Send Invoice',
        values: ['yesCoopDFI', 'YES Co-op DFI %', 'YES Co-op installment-Track Expenses', 'YES Co-op, Do Not Send Invoice'],
    },
];

export function ManufacturerHelpSection() {
    return (
        <Row className="mb-2 text-start">
            <Col>
                <p>Manufacturer part # is used by designers to find images. List PNs for items you want pictured.</p>
            </Col>
        </Row>
    );
}

export function VendorSelection({
    formState,
    setFormState,
    fieldName,
    inputLabel,
    asterisk,
    placeholder,
    vendors,
}) {
    const [vendorFilter, setVendorFilter] = useState('');
    const vendorNameByCode = new Map(
        (vendors || []).map((vendor) => [vendor.d365_code, vendor.name])
    );

    const parseVendorCodes = (value) => (
        (value || '')
            .split(',')
            .map((vendorCode) => vendorCode.trim())
            .filter((vendorCode) => vendorCode !== '')
    );

    const selectedVendors = parseVendorCodes(formState[fieldName]);

    const filteredVendors = vendors.filter((vendor) => {
        const venFilter = vendorFilter.toLowerCase();
        if (vendorFilter === '') {
            return vendor;
        }
        return (
            vendor.name.toLowerCase().includes(venFilter)
            || vendor.d365_code.toLowerCase().includes(venFilter)
        );
    });

    const appendVendorCode = (value) => {
        if (!value) {
            return;
        }

        setFormState((prev) => {
            const existingVendors = parseVendorCodes(prev[fieldName]);
            if (existingVendors.includes(value)) {
                return prev;
            }

            const updatedVendors = [...existingVendors, value];
            return {
                ...prev,
                [fieldName]: updatedVendors.join(', '),
            };
        });
    };

    const removeVendorCode = (value) => {
        setFormState((prev) => {
            const updatedVendors = parseVendorCodes(prev[fieldName]).filter((vendorCode) => vendorCode !== value);
            return {
                ...prev,
                [fieldName]: updatedVendors.join(', '),
            };
        });
    };

    const formatSelectedVendor = (vendorCode) => {
        const vendorName = vendorNameByCode.get(vendorCode);
        if (!vendorName) {
            return vendorCode;
        }
        return `${vendorName} - ${vendorCode}`;
    };

    return (
        <>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column xs={2} className="formInput">Add Vendor</Form.Label>
                <Col xs={4}>
                    <Form.Control
                        value={vendorFilter}
                        onChange={(event) => setVendorFilter(event.target.value)}
                        placeholder="Start typing to filter vendors..."
                    />
                </Col>
                <Col xs={5}>
                    <Form.Select value="" onChange={(event) => appendVendorCode(event.target.value)}>
                        <option value="" key="">Select to Add Vendor Code</option>
                        {filteredVendors.map((vendor, index) => (
                            <option value={vendor.d365_code} key={`${vendor.d365_code}-${index}`}>
                                {`${vendor.name} - ${vendor.d365_code}`}
                            </option>
                        ))}
                    </Form.Select>
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3">
                <Form.Label column xs={2} className="formInput">
                    {inputLabel}
                    {asterisk ? <span style={{ color: 'red' }}>*</span> : null}
                </Form.Label>
                <Col xs={9} className="d-flex flex-wrap gap-2">
                    {selectedVendors.length === 0 ? (
                        <span>{placeholder || 'No vendors selected'}</span>
                    ) : (
                        selectedVendors.map((vendorCode) => (
                            <span key={vendorCode} className="border rounded px-2 py-1 d-inline-flex align-items-center gap-2">
                                <span>{formatSelectedVendor(vendorCode)}</span>
                                <button type="button" onClick={() => removeVendorCode(vendorCode)} aria-label={`Remove ${vendorCode}`}>
                                    ×
                                </button>
                            </span>
                        ))
                    )}
                </Col>
            </Form.Group>
        </>
    );
}

export function NewProductImageStatusSection({ isNewProduct, newImageState, setNewImageState }) {
    if (!isNewProduct) {
        return null;
    }

    return (
        <Row style={{ backgroundColor: '#ffe5f6', paddingTop: '15px' }} className="mb-3">
            <Col xs={8} className="d-flex">
                <h5 className="text-start">PRODUCT IMAGE STATUS</h5>
                <p>&nbsp;&nbsp;&nbsp;(MUST SELECT ONE):<span style={{ color: 'red', fontWeight: 'bold', fontSize: 18 }}>*</span></p>
            </Col>
            <Row>
                <Col xs={8}>
                    <Form.Check
                        checked={newImageState.currentlyLiveCheck}
                        className="formInput"
                        type="checkbox"
                        label="Product is currently live on murdochs.com:"
                        style={{ textAlign: 'start', textDecoration: 'none' }}
                        onChange={() => setNewImageState((prev) => ({ ...prev, currentlyLiveCheck: !prev.currentlyLiveCheck }))}
                    />
                </Col>
                <TextInput inputName="currentlyLive" inputLabel="URL:" inputValue={newImageState.currentlyLive} changeFunc={(e) => setNewImageState((prev) => ({ ...prev, currentlyLive: e.target.value }))} />
            </Row>
            <Row>
                <Col xs={8}>
                    <Form.Check
                        checked={newImageState.sentToVendorCheck}
                        className="formInput"
                        type="checkbox"
                        label="PPL has been sent to vendor"
                        style={{ textAlign: 'start', textDecoration: 'none' }}
                        onChange={() => setNewImageState((prev) => ({ ...prev, sentToVendorCheck: !prev.sentToVendorCheck }))}
                    />
                </Col>
                <TextInput inputName="sentToVendor" inputLabel="Date Sent:" inputValue={newImageState.sentToVendor} changeFunc={(e) => setNewImageState((prev) => ({ ...prev, sentToVendor: e.target.value }))} />
            </Row>
            <Row>
                <Col xs={8}>
                    <Form.Check
                        checked={newImageState.commentsCheck}
                        className="formInput"
                        type="checkbox"
                        label="Notes for designer on product image status:"
                        style={{ textAlign: 'start', textDecoration: 'none' }}
                        onChange={() => setNewImageState((prev) => ({ ...prev, commentsCheck: !prev.commentsCheck }))}
                    />
                </Col>
                <TextAreaInput inputName="comments" inputLabel="Comments:" inputValue={newImageState.comments} changeFunc={(e) => setNewImageState((prev) => ({ ...prev, comments: e.target.value }))} />
            </Row>
        </Row>
    );
}

export function CoopPreApprovalField({ checked, changeFunc }) {
    return (
        <Row className="mb-3">
            <Col xs={5} className="align-items-center text-start">
                <Form.Check
                    className="formInput"
                    type="checkbox"
                    name="coop_pre_approval"
                    label="Pre-approval Required"
                    checked={Boolean(checked)}
                    onChange={changeFunc}
                />
            </Col>
        </Row>
    );
}

export function CoopEligibilityField({ value, changeFunc }) {
    return (
        <Form.Group as={Row} className="mb-3 text-start ms-1">
            {COOP_ELIGIBILITY_OPTIONS.map((option) => (
                <Col lg={7} key={option.value}>
                    <Form.Check
                        name="coop_eligible"
                        inline
                        type="radio"
                        onChange={changeFunc}
                        value={option.value}
                        label={option.label}
                        checked={option.values.includes(value)}
                    />
                </Col>
            ))}
        </Form.Group>
    );
}

export function CopySymbolsSection() {
    return (
        <Row className="mb-3 align-items-center text-start">
            <Form.Label column xs={3} className="formInput" style={{ paddingLeft: '2%', fontSize: '20px' }}>Click to Copy:</Form.Label>
            {['®', '™', '½', '¼', '¾'].map((symbol) => (
                <Col xs={1} className="d-grid" key={symbol}>
                    <button type="button" onClick={() => navigator.clipboard.writeText(symbol)}>{symbol}</button>
                </Col>
            ))}
        </Row>
    );
}
